import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type CompositionItem = {
    id: number,
    title: any,
    value: string,
    type: any  
}

type CompositionItemDto = {
    title: any,
    value: string,
    type: number[]
}

export const CompositionItemsApi = createApi({
    reducerPath: 'CompositionItemsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["COMPOSITION-ITEMS"],
    endpoints: builder => ({
        getAllCompositionItems: builder.query<CompositionItem[], void>({
            query: () => ({ url: `/composition-items` }),
            providesTags: ["COMPOSITION-ITEMS"]
        }),
        getCompositionItem: builder.query<CompositionItem, { id: number }>({
            query: ({ id }) => ({ url: `/composition-items/${id}` }),
            providesTags: ["COMPOSITION-ITEMS"]
        }),
        createCompositionItem: builder.mutation<any, CompositionItemDto>({
            query: (body) =>({url: `/composition-items`, method: "POST", body: body}),
            invalidatesTags: ["COMPOSITION-ITEMS"]
        })
    })
})

export const { useGetAllCompositionItemsQuery, useGetCompositionItemQuery, useCreateCompositionItemMutation } = CompositionItemsApi
